// @flow

import alt from '../alt';

class SettingsActions {
	settingsUpdated(settings) {
		return settings;
	}
}

export default alt.createActions(SettingsActions);
